(function(){
  "use strict";
  function throttle(fn,wait){var t=0,id;return function(){var now=Date.now(),ctx=this,a=arguments,rem=wait-(now-t);if(rem<=0){t=now;fn.apply(ctx,a);}else{clearTimeout(id);id=setTimeout(function(){t=Date.now();fn.apply(ctx,a);},rem);}};}
  var FINE_HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function Carousel(root){
    this.root=root;
    this.viewport=root.querySelector('[data-sqa-viewport]');
    this.track=root.querySelector('[data-sqa-track]');
    if(!this.viewport||!this.track)return;
    this.slides=Array.prototype.slice.call(this.track.children);
    this.count=this.slides.length;
    this.dotsWrap=root.querySelector('[data-sqa-dots]');
    this.prevBtn=root.querySelector('[data-sqa-prev]');
    this.nextBtn=root.querySelector('[data-sqa-next]');
    this.stepMode=root.getAttribute('data-step')||'page';
    this.autoplay=parseInt(root.getAttribute('data-autoplay')||'0',10);
    this.resumeDelay=parseInt(root.getAttribute('data-resume')||'4000',10);
    this.index=0;this.cardStep=0;this.visible=2;this.positions=1;this._lastVpW=-1;
    this.timer=null;
    this.pauseUntil=0;    /* time-boxed pause after interaction (auto-expires) */
    this.hoverPaused=false; /* desktop mouse hover only */
    this.dragging=false;  /* active finger drag in progress */
    this.offscreen=false; /* out of the viewport / hidden tab */
    this.bind();
    this.recalc(true);
    this.startAuto();
  }
  var P=Carousel.prototype;

  P.visForWidth=function(){
    var w=window.innerWidth;
    var vm=parseFloat(this.root.getAttribute('data-visible-mobile')||'2');
    var vt=parseFloat(this.root.getAttribute('data-visible-tablet')||'3');
    var vd=parseFloat(this.root.getAttribute('data-visible-desktop')||'4');
    if(w<=749)return vm;if(w<=1023)return vt;return vd;
  };
  P.recalc=function(force){
    var vpW=this.viewport.clientWidth;
    if(vpW===0)return;                       /* hidden (inactive tab) */
    if(!force && vpW===this._lastVpW)return;  /* ignore mobile URL-bar (height-only) resize spam */
    this._lastVpW=vpW;
    this.visible=Math.max(1,Math.min(this.count,this.visForWidth()));
    this.root.style.setProperty('--sqa-vis',this.visible);
    var s0=this.slides[0];
    if(s0){
      var cs=getComputedStyle(this.track);
      var gap=parseFloat(cs.columnGap||cs.gap||'0')||0;
      this.cardStep=s0.getBoundingClientRect().width+gap;
    }
    this.positions=(this.stepMode==='one')?Math.max(1,this.count-this.visible+1):Math.max(1,Math.ceil(this.count/this.visible));
    if(this.index>this.positions-1)this.index=this.positions-1;
    this.renderDots();
    this.apply(false);
  };
  P.cardIndexFor=function(i){var m=Math.max(0,this.count-this.visible);return (this.stepMode==='one')?Math.min(i,m):Math.min(i*this.visible,m);};
  P.apply=function(animate){
    var x=-this.cardIndexFor(this.index)*this.cardStep;
    this.track.style.transition=animate?'transform .6s cubic-bezier(.22,.61,.36,1)':'none';
    this.track.style.transform='translate3d('+x+'px,0,0)';
    if(this.dotsWrap){var d=this.dotsWrap.children;for(var k=0;k<d.length;k++)d[k].classList.toggle('is-active',k===this.index);}
    if(this.prevBtn)this.prevBtn.disabled=this.index<=0;
    if(this.nextBtn)this.nextBtn.disabled=this.index>=this.positions-1;
  };
  P.go=function(i,animate){if(i<0)i=0;if(i>this.positions-1)i=this.positions-1;this.index=i;this.apply(animate!==false);};
  P.next=function(loop){if(this.index>=this.positions-1){if(loop)this.go(0);else this.apply(true);}else this.go(this.index+1);};
  P.prev=function(){if(this.index<=0)this.apply(true);else this.go(this.index-1);};
  P.renderDots=function(){
    var self=this;
    if(this.prevBtn)this.prevBtn.style.display=this.positions>1?'':'none';
    if(this.nextBtn)this.nextBtn.style.display=this.positions>1?'':'none';
    if(!this.dotsWrap)return;
    if(this.dotsWrap.children.length!==this.positions){
      this.dotsWrap.innerHTML='';
      for(var i=0;i<this.positions;i++){
        var b=document.createElement('button');
        b.type='button';b.className='sqa-c__dot';b.setAttribute('aria-label','Go to slide '+(i+1));
        (function(idx){b.addEventListener('click',function(){self.pause();self.go(idx);});})(i);
        this.dotsWrap.appendChild(b);
      }
    }
    this.dotsWrap.style.display=this.positions>1?'':'none';
  };
  /* Time-boxed pause: never sticky. Autoplay resumes automatically once the window passes. */
  P.pause=function(){this.pauseUntil=Date.now()+this.resumeDelay;};
  P.startAuto=function(){
    if(!this.autoplay)return; var self=this; this.stopAuto();
    this.timer=setInterval(function(){
      if(document.hidden)return;
      if(self.hoverPaused)return;      /* desktop hover */
      if(self.dragging)return;         /* finger down, mid-drag */
      if(self.offscreen)return;        /* scrolled away / hidden tab */
      if(Date.now()<self.pauseUntil)return; /* recent interaction, auto-expires */
      if(self.positions<=1)return;
      if(self.root.offsetParent===null)return; /* display:none */
      self.next(true);                 /* infinite loop */
    }, this.autoplay);
  };
  P.stopAuto=function(){if(this.timer){clearInterval(this.timer);this.timer=null;}};
  P.bind=function(){
    var self=this;
    if(this.prevBtn)this.prevBtn.addEventListener('click',function(){self.pause();self.prev();});
    if(this.nextBtn)this.nextBtn.addEventListener('click',function(){self.pause();self.next(false);});
    /* Hover-pause ONLY on true mouse pointers. Touch devices fire a synthetic mouseenter
       with no matching mouseleave, which previously stuck the carousel paused forever. */
    if(FINE_HOVER){
      this.root.addEventListener('mouseenter',function(){self.hoverPaused=true;});
      this.root.addEventListener('mouseleave',function(){self.hoverPaused=false;});
    }
    this.root.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){self.pause();self.next(false);}else if(e.key==='ArrowLeft'){self.pause();self.prev();}});
    var startX=0,startY=0,dx=0,decided=false,horiz=false;
    var vp=this.viewport;
    vp.addEventListener('touchstart',function(e){var t=e.touches[0];startX=t.clientX;startY=t.clientY;dx=0;self.dragging=true;decided=false;horiz=false;self.pause();self.track.style.transition='none';},{passive:true});
    vp.addEventListener('touchmove',function(e){
      if(!self.dragging)return;var t=e.touches[0];dx=t.clientX-startX;var dy=t.clientY-startY;
      if(!decided){decided=true;horiz=Math.abs(dx)>Math.abs(dy);if(!horiz){self.dragging=false;return;}}
      var base=-self.cardIndexFor(self.index)*self.cardStep;
      self.track.style.transform='translate3d('+(base+dx)+'px,0,0)';
    },{passive:true});
    function endDrag(){
      if(!self.dragging){self.pause();return;}
      self.dragging=false;
      var th=Math.min(70,self.cardStep*0.2);
      if(dx<=-th)self.next(false);else if(dx>=th)self.prev();else self.apply(true);
      self.pause();
    }
    vp.addEventListener('touchend',endDrag);
    vp.addEventListener('touchcancel',endDrag);
    window.addEventListener('resize',throttle(function(){self.recalc(false);},150));
    if('ResizeObserver' in window){var ro=new ResizeObserver(function(){self.recalc(false);});ro.observe(this.viewport);}
    /* Pause off-screen, resume when scrolled back into view (never permanent) */
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){self.offscreen=!en.isIntersecting;});},{threshold:0.05});
      io.observe(this.root);
    }
  };

  function initAll(ctx){
    var els=(ctx||document).querySelectorAll('[data-sqa-carousel]');
    for(var i=0;i<els.length;i++){var el=els[i];if(el.dataset.sqaInit)continue;el.dataset.sqaInit='1';try{new Carousel(el);}catch(e){}}
  }
  window.SQACarousel={init:initAll};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll();});
  else initAll();
})();
